export const MAIN_RESPONSIVE = " w-full min-w-[20em]  md:m-auto"